export default __webpack_public_path__ + "static/media/end_hand.97c91844.mp3";